import { Injectable, inject } from '@angular/core';
import { AuthRepositoryService, TenantTemplateOptionModel } from 'baseflow-auth';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { ITenant, ITenantConfig, ITenantConfigPUT, TenantApiService } from 'shared';

@Injectable({ providedIn: 'root' })
export class TenantService {
    private authRepository = inject(AuthRepositoryService);
    private tenantApi = inject(TenantApiService);

    private tenant?: ITenant;

    public getTenantTemplates(language = 'en'): Observable<Array<TenantTemplateOptionModel>> {
        return this.authRepository.getTenantTemplates(language);
    }

    public updateTenant(name: string, tenantTemplateId: string): Observable<ITenant> {
        return this.authRepository.updateTenant(name, tenantTemplateId, this.tenant?.id);
    }

    public createTenant(name: string): Observable<ITenant> {
        return this.tenantApi.createTenant(name);
    }

    public setActiveTenant(tenant: ITenant): void {
        this.tenant = tenant;
    }

    public getActiveTenant(): ITenant {
        return this.tenant;
    }

    public updateConfig(config: Omit<ITenantConfig, 'id' | 'ordinals' | 'tables'>): Observable<boolean> {
        if (!this.tenant) return throwError(() => 'Cannot update tenant config without an active tenant.');
        const { mapBox, ...rest } = config;
        const data: ITenantConfigPUT = { ...rest, ...mapBox };
        return this.tenantApi.updateConfig(data, this.tenant.id).pipe(map(Boolean));
    }
}
